import { render, staticRenderFns } from "./Method.vue?vue&type=template&id=2014d341&scoped=true"
import script from "./Method.vue?vue&type=script&lang=js"
export * from "./Method.vue?vue&type=script&lang=js"
import style0 from "./Method.vue?vue&type=style&index=0&id=2014d341&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2014d341",
  null
  
)

export default component.exports